module.exports = __webpack_public_path__ + "img/特色文化名片图标.efe18cb6.svg";